module.exports = __webpack_public_path__ + "dc5644e49783c70f58bfc85ed2cb0639.png";